import { RawStore, StoreEntity } from './Types';
import { BaseModel } from '../BaseModel/BaseModel';

export class StoreModel extends BaseModel<RawStore, StoreEntity> implements StoreEntity {
    endDate: string = '';
    price: string = '';
    pricePrev: string = '';
    quantity: number = 0;
    quantityPrev: number = 0;

    constructor(data?: RawStore) {
        super();
        if(data) {
            this.initialize(data);
        }
    }

    initialize(data: RawStore) {
        this.endDate = data.end_date;
        this.price = data.price_prev;
        this.pricePrev = data.price_prev;
        this.quantity = data.quantity;
        this.quantityPrev = data.quantity_prev;
    }

    parse(): RawStore {
        return {
            end_date: this.endDate,
            price: this.price,
            price_prev: this.pricePrev,
            quantity: this.quantity,
            quantity_prev: this.quantityPrev,
        };
    }
}